import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Image } from "react-bootstrap";
import secureShield from "../../assets/secure-shield.png";

export class LoginDesc extends Component {
  render() {
    const { accountHeading, buttonText, buttonLink, subHeading } = this.props;
    return (
      <React.Fragment>
        <div className="no-account-inner">
          <div className="login-desc">
            <div className="have-account">
              <div className="have-acc-inner">
                <h2 className="have-account-heading">{accountHeading}</h2>
                <h3>{subHeading}</h3>
              </div>
              <Link to={buttonLink} className="secondary-btn">
                <Button
                  variant="secondary"
                  className="btn-white"
                  data-test="login-register-button"
                >
                  {buttonText}
                </Button>
              </Link>
              <div className="security-box">
                <img src={secureShield} alt="security" />
                <div>Secure Information</div>
                <p>
                  We won't reveal your information to anyone else nor use it to
                  send you spam
                </p>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default LoginDesc;
